var map = {
	"./dark-logo.svg": [
		74787,
		7168
	],
	"./default-logo.svg": [
		38515,
		8515
	],
	"./gl-logo.svg": [
		86871,
		6871
	],
	"./gl-old-logo.svg": [
		65487,
		5487
	],
	"./vc-logo.svg": [
		60099,
		99
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 42672;
module.exports = webpackAsyncContext;